// extracted by mini-css-extract-plugin
module.exports = {"noData":"_995847a","skeleton":"_51c0578","dropdownSkeleton":"_46d6b1b","tableSkeleton":"_829a726"};